export const RATES_UPDATED_KEY  = 'pocketpm_rates_updated_at';
export const CACHES_CLEARED_KEY = 'pocketpm_caches_cleared_at';

/**
 * Call after any rate save to mark in-memory caches as dirty.
 */
export function markRatesUpdated() {
  sessionStorage.setItem(RATES_UPDATED_KEY, String(Date.now()));
}

/**
 * Returns true if in-memory caches should be cleared before fetching.
 * True on first load (no recorded clear) or when rates were saved after the last clear.
 */
export function isCacheClearNeeded() {
  const ratesUpdatedAt  = sessionStorage.getItem(RATES_UPDATED_KEY);
  const cachesClearedAt = sessionStorage.getItem(CACHES_CLEARED_KEY);
  return (
    !cachesClearedAt ||
    (ratesUpdatedAt !== null && Number(ratesUpdatedAt) > Number(cachesClearedAt))
  );
}

/**
 * Record that all in-memory caches have just been cleared.
 */
export function markCachesCleared() {
  sessionStorage.setItem(CACHES_CLEARED_KEY, String(Date.now()));
}
